import { powerUpSdkStrings } from "@vendata/power-up-sdk/strings";
import { powerUpCommonStrings } from "@vendata/power-up-clients-common/strings";
import { auth_strings as kratos_auth_strings } from "@saflib/ory-kratos-spa/strings";

// BEGIN SORTED WORKFLOW AREA string-imports FOR vue/add-view sdk/add-component
import { account_settings_section } from "./pages/account-settings/AccountSettingsSection.strings.ts";
import { account_home_company_profile } from "./pages/home-page/AccountCompanyProfileCard.strings.ts";
import { account_home_mfa } from "./pages/home-page/AccountMfaCard.strings.ts";
import { account_home_password } from "./pages/home-page/AccountPasswordCard.strings.ts";
import { account_home_personal_info } from "./pages/home-page/AccountPersonalInfoCard.strings.ts";
import { company_profile_page } from "./pages/company-profile/CompanyProfile.strings.ts";
import { home_page } from "./pages/home-page/HomePage.strings.ts";
import { support_page } from "./pages/support/Support.strings.ts";
// END WORKFLOW AREA

export const account_strings = {
  // BEGIN SORTED WORKFLOW AREA string-object FOR vue/add-view sdk/add-component
  account_home_company_profile,
  account_home_mfa,
  account_home_password,
  account_home_personal_info,
  account_settings_section,
  company_profile_page,
  home_page,
  support_page,
  // END WORKFLOW AREA
  ...kratos_auth_strings,
  ...powerUpSdkStrings,
  ...powerUpCommonStrings,
};
